export default {"src":"/_next/static/media/travelOutline100_40.8d47f5cf.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};